import { EnvironmentConfig } from './config';
import { Optional, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private ws: WebSocket;

  constructor(@Optional() private config: EnvironmentConfig) {}

  get instance() {
    return this.ws;
  }

  init(id: string) {
    if (!this.ws) {
      this.ws = new WebSocket(this.config.socketUrl + '/' + id);

      this.ws.onopen = () => {
        // console.log('Websocket connection is opened.');
      };

      this.ws.onclose = () => {
        // console.log('Websocket connection is closed.');
      };

      window.onbeforeunload = (event: any) => {
        this.close();
      };
    }

  }

  close() {
    if (this.ws !== undefined) {
      this.ws.close();
      // this.ws = undefined;
    }
  }

}
